module.exports = __webpack_public_path__ + "img/immersion-list.c035486d.png";